var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeLightt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.564 17.6585C11.304 17.7685 11.024 17.8685 10.724 17.9685L9.14401 18.4885C5.17401 19.7685 3.08401 18.6985 1.79401 14.7285L0.514013 10.7785C-0.765987 6.80846 0.294013 4.70846 4.26401 3.42846L5.80401 2.91846C5.61401 3.39846 5.45401 3.94846 5.30401 4.56846L4.32401 8.75846C3.22401 13.4685 4.83401 16.0685 9.54401 17.1885L11.224 17.5885C11.334 17.6185 11.454 17.6385 11.564 17.6585Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.184 0.708543L13.514 0.318543C10.174 -0.471457 8.18401 0.178543 7.01401 2.59854C6.71401 3.20854 6.47401 3.94854 6.27401 4.79854L5.29401 8.98854C4.31401 13.1685 5.60401 15.2285 9.77401 16.2185L11.454 16.6185C12.034 16.7585 12.574 16.8485 13.074 16.8885C16.194 17.1885 17.854 15.7285 18.694 12.1185L19.674 7.93854C20.654 3.75854 19.374 1.68854 15.184 0.708543Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLightt);
export default __webpack_public_path__ + "static/media/HomeLightt.850520d4266c4ecce281b61744b42acd.svg";
export { ForwardRef as ReactComponent };